import React, { memo } from "react";
import {
  Box,
  Typography,
  Button,
  Link,
  makeStyles,
  useTheme,
} from "@material-ui/core";
import { Error } from "@material-ui/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  emailLink: {
    textDecoration: "underline",
    color: "inherit",
    "&:hover": {
      color: theme.palette.primary.main,
      textDecoration: "none",
    },
  },
}));

const FullPageError = ({ mainErrorVerbiage, supportErrorVerbiage }) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const onHome = () => {
    history.push("/");
  };
  const defaultMainErrorVerbiage = "Please refresh the page to try again.";
  const defaultSupportErrorVerbiage = "If the problem continues, ";

  const mainErrorVerbiageDisplay =
    mainErrorVerbiage || defaultMainErrorVerbiage;
  const supportErrorVerbiageDisplay =
    supportErrorVerbiage || defaultSupportErrorVerbiage;

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      style={{ backgroundColor: theme.palette.common.white }}
    >
      <Typography variant="h3" color="error" gutterBottom>
        <Error fontSize="large" /> Error Occurred
      </Typography>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        style={{ marginBottom: 10 }}
      >
        {mainErrorVerbiageDisplay}
      </Typography>
      <Typography variant="subtitle1" color="textSecondary" align="center">
        {supportErrorVerbiageDisplay}reach out to your Customer Success Manager
        or email us at{" "}
        <Link
          href="mailto:support@goconvey.zendesk.com"
          className={classes.emailLink}
        >
          support@goconvey.zendesk.com
        </Link>
      </Typography>
      <Button
        style={{ marginTop: 16 }}
        variant="contained"
        color="primary"
        onClick={onHome}
      >
        Go Home
      </Button>
    </Box>
  );
};

export default memo(FullPageError);
